var app;

app = window.App || (window.App = {});

app.HelpTextToggler = {
  hideAll: function() {
    return $('.help-text[data-initially-closed').hide();
  },
  toggle: function(e) {
    return $('.' + $(this).data('key')).slideToggle();
  }
};

app.HelpTextForm = {
  syncSelectFields: function() {
    var activeContext;
    activeContext = $('#help_text_context').val();
    $('.help_text_context_keys').addClass('d-none').find('select').prop("disabled", true);
    return $(document.getElementById(activeContext)).removeClass('d-none').find('select').prop("disabled", false);
  }
};

$(document).on('click', '.help-text-trigger', app.HelpTextToggler.toggle);

$(document).on('change', '#help_text_context', app.HelpTextForm.syncSelectFields);

$(document).on('turbo:load', function() {
  app.HelpTextToggler.hideAll();
  return app.HelpTextForm.syncSelectFields();
});
